import styled from "styled-components";
import { Swiper, SwiperSlide } from "swiper/react";
import { MEDIA_DESKTOP } from "../../../../hooks/useScreenOrientation";
import { areaList } from "../type/area";
import { useRecoilValue } from "recoil";
import { insetState } from "../../../../recoil/inset";
const FranchiseAreaFilterWrapper = styled.div<{ isApp: number | null }>`
  background: white;
  padding-left: 16px;
  padding-bottom: 8px;
  position: fixed;
  top: ${(p) => (p.isApp ? `${p.isApp + 40}px` : "40px")};
  width: 100%;
  display: flex;
  background: white;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  z-index: 11;
  @media ${MEDIA_DESKTOP} {
    gap: 20px;
  }

  .filter-list {
    margin-top: 20px;
    width: 100%;
    height: 30px;

    .swiper-slide {
      width: auto !important;

      &:last-child {
        margin-right: 32px;
      }
    }
  }

  .like-icon {
    width: 30px;
    height: 30px;
  }
`;

const CardItemWrapper = styled.div<{ isSelected: boolean }>`
  padding: 0 12px;
  border-radius: 15px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid
    ${(p) => (p.isSelected ? "#6436E7" : "var(--Black-200, #B7B7B7)")};
  color: ${(p) => (p.isSelected ? "#fff" : "var(--Black-500, #202020)")};
  background: ${(p) => (p.isSelected ? "#6436E7" : "#fff")};
  font-family: Pretendard;
  font-size: 12px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
`;

interface FranchiseAreaFilterProps {
  setArea: (area: { name: string; value: number[] | null }) => void;
  selectedArea: { name: string; value: number[] | null };
  isMyPub: boolean;
  setIsMyPub: (isMyPub: boolean) => void;
}

const FranchiseAreaFilter = ({
  setArea,
  selectedArea,
  isMyPub,
  setIsMyPub,
}: FranchiseAreaFilterProps) => {
  const inset = useRecoilValue(insetState);
  return (
    <FranchiseAreaFilterWrapper isApp={inset}>
      <Swiper
        className="filter-list"
        slidesPerView="auto"
        spaceBetween={6}
        freeMode={true}
        watchSlidesProgress={true}
        resistanceRatio={0}
      >
        <SwiperSlide>
          <img
            className="like-icon"
            src={
              isMyPub ? "/image-web/pub/like.svg" : "/image-web/pub/un-like.svg"
            }
            alt="arrow"
            onClick={() => setIsMyPub(!isMyPub)}
          />
        </SwiperSlide>

        {areaList.map((item, index) => (
          <SwiperSlide key={index}>
            <CardItemWrapper
              onClick={() => setArea(item)}
              isSelected={selectedArea.name === item.name}
            >
              {item.name}
            </CardItemWrapper>
          </SwiperSlide>
        ))}
      </Swiper>
    </FranchiseAreaFilterWrapper>
  );
};

export default FranchiseAreaFilter;
